'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return Date.now() % 100000000 + '_' + Math.round(Math.random() * 10000);
};

;